<template>
  <div class="content">
    <h1>Apliecību izsūtīšanas</h1>
    <TableContent
      :table-info="userTableInfo"
      name="user_courses"
      filter="filter[is_certificate_accepted]=true"
    ></TableContent>
  </div>
</template>

<script>
import TableContent from "@/Admin/components/TableContent.vue";
import AllowCourseAccessAction from "@/Admin/components/form_actions/AllowCourseAccessAction.vue";
import AcceptLicenseOrderAction from "@/Admin/components/form_actions/AcceptLicenseOrderAction.vue";
import DeliverLicenseOrderAction from "@/Admin/components/form_actions/DeliverLicenseOrderAction.vue";

export default {
  name: "LicenseDeliveryListView",
  components: { TableContent },
  data: () => ({
    userTableInfo: {
      headers: [
        {
          title: "Rēķina nr.",
          align: "start",
          key: "invoice_number",
        },
        {
          title: "Kurss",
          align: "start",
          key: "course.name",
        },
        {
          title: "Vārds",
          align: "start",
          key: "user.firstname",
        },
        {
          title: "Uzvārds",
          align: "start",
          key: "user.lastname",
        },
        {
          title: "E-pasts",
          align: "start",
          key: "user.email",
        },
        {
          title: "Telefona nr.",
          align: "start",
          key: "user.phone_number",
        },
        {
          title: "Piegādes adrese",
          align: "start",
          key: "invoice.delivery_location",
        },
        {
          title: "Izsūtīts",
          align: "start",
          key: "is_certificate_delivered",
        },
        {
          title: "Darbības",
          align: "start",
          sortable: false,
          key: "actions",
        },
      ],
      actions: [DeliverLicenseOrderAction],
    },
  }),
};
</script>

<style scoped>
.content {
  width: 100%;
}
</style>
